import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
} from "@mui/material";
import React from "react";
import ButtonCta1 from "../button/ButtonCta1";
import { styled } from "@mui/system";

const CustomDialog = styled(Dialog)(({ theme }) => ({
  "&.MuiDialog-paper": {
    borderRadius: 12,
  },
}));

const DisclaimerDialog = ({
  open,
  handleDone,
  title,
  userName,
  subTitle,
  rightButtonText,
  onClose,
}) => {
  const greeting = `Dear ${userName},`;

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          color: "#a50218",
          fontFamily: "Montserrat",
          padding: "32px 32px 12px 32px",
          fontWeight: 600,
        }}
      >
        {title || ""}
      </DialogTitle>
      <DialogContent sx={{ minWidth: "600px", padding: "20px 32px" }}>
        {userName && (
          <>
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                fontSize: "14px",
                fontFamily: "Montserrat",
                fontWeight: 500,
              }}
              dangerouslySetInnerHTML={{ __html: greeting }}
            />
            <br />
          </>
        )}
        <DialogContentText
          id="alert-dialog-description"
          sx={{ fontSize: "14px", fontFamily: "Montserrat", fontWeight: 500 }}
          dangerouslySetInnerHTML={{ __html: subTitle }}
        />
        {userName && (
          <>
            <br />
            <DialogContentText
              id="alert-dialog-description"
              sx={{
                fontSize: "14px",
                fontFamily: "Montserrat",
                fontWeight: 500,
              }}
              dangerouslySetInnerHTML={{ __html: "Team Visualise" }}
            />
          </>
        )}
        {/* {subTitle || ""}
          </DialogContentText> */}
        <Divider sx={{ height: "0.5px", marginTop: "20px" }} />
      </DialogContent>
      <DialogActions sx={{ padding: "0 32px 20px 32px" }}>
        <Box style={{ marginLeft: "20px" }}>
          <ButtonCta1
            text={rightButtonText}
            variant="contained"
            onClick={handleDone}
            autoFocus
            bgColor="#a50218"
            color="#fff"
          />
        </Box>
      </DialogActions>
    </CustomDialog>
  );
};

export default DisclaimerDialog;
